export default __webpack_public_path__ + "images/SpeakersPhotos/Alejandro_Orviz_Bluco.jpg?e3653127";